import {
  parseAvgDurationSeconds,
  parseFrequencyPerDay,
  parseGreenTimeDays,
  parseMttfHours,
  parseThresholdValue,
  type MetricThresholdDrafts,
} from '@/features/projects/metricThresholdDrafts';
import type { MetricThresholdGroup } from '@flowqa/shared';

type MetricThresholdEnabledState = {
  passRate: boolean;
  frequency: boolean;
  avgDuration: boolean;
};

export const buildMetricThresholdPayload = (
  drafts: MetricThresholdDrafts,
  enabled: MetricThresholdEnabledState,
  current: MetricThresholdGroup,
): MetricThresholdGroup => ({
  passRate: {
    target: parseThresholdValue(drafts.passRate.target) ?? current.passRate.target,
    warn: parseThresholdValue(drafts.passRate.warn) ?? current.passRate.warn,
    direction: 'higherBetter',
    enabled: enabled.passRate,
  },
  frequency: {
    target:
      parseFrequencyPerDay(drafts.frequency.targetValue, drafts.frequency.targetUnit) ??
      current.frequency.target,
    warn:
      parseFrequencyPerDay(drafts.frequency.warnValue, drafts.frequency.warnUnit) ??
      current.frequency.warn,
    direction: 'higherBetter',
    enabled: enabled.frequency,
    targetUnit: drafts.frequency.targetUnit,
    warnUnit: drafts.frequency.warnUnit,
  },
  avgDuration: {
    target:
      parseAvgDurationSeconds(drafts.avgDuration.targetValue, drafts.avgDuration.targetUnit) ??
      current.avgDuration.target,
    warn:
      parseAvgDurationSeconds(drafts.avgDuration.warnValue, drafts.avgDuration.warnUnit) ??
      current.avgDuration.warn,
    direction: 'lowerBetter',
    enabled: enabled.avgDuration,
    targetUnit: drafts.avgDuration.targetUnit,
    warnUnit: drafts.avgDuration.warnUnit,
  },
  flakeScore: {
    target: parseThresholdValue(drafts.flakeScore.target) ?? current.flakeScore.target,
    warn: parseThresholdValue(drafts.flakeScore.warn) ?? current.flakeScore.warn,
    direction: 'lowerBetter',
    enabled: current.flakeScore.enabled,
  },
  mttf: {
    target: parseMttfHours(drafts.mttf.targetValue, drafts.mttf.targetUnit) ?? current.mttf.target,
    warn: parseMttfHours(drafts.mttf.warnValue, drafts.mttf.warnUnit) ?? current.mttf.warn,
    direction: 'higherBetter',
    enabled: current.mttf.enabled,
  },
  greenTime: {
    target:
      parseGreenTimeDays(drafts.greenTime.targetValue, drafts.greenTime.targetUnit) ??
      current.greenTime.target,
    warn:
      parseGreenTimeDays(drafts.greenTime.warnValue, drafts.greenTime.warnUnit) ??
      current.greenTime.warn,
    direction: 'higherBetter',
    enabled: current.greenTime.enabled,
  },
});
